/**
 * Tries to return the most relevant error message from an error returned by a service
 * 
 * @param {error} err - the error to get the message from
 * @returns {string} the error message
 */
export function getServiceErrorMessage(err) {
    console.warn('getServiceErrorMessage', err);

    if (err) {
        const data = err.data || err.response?.data;

        if (data) {
            const status = data.statusText || data.status;
            if (typeof data === 'string') {
                return new Error(`${status}: ${data}`);
            }
            if (data.message) {
                return new Error(`${status}: ${data.message}`);
            }
        }

        if (err.code && err.message) {
            return new Error(`${err.code}: ${err.message}`);
        } else if (err.message) {
            return new Error(err.message);
        }
    }

    return new Error('AN UNKNOWN ERROR OCCURRED');
}